export default {
    methods: {
        judgeDevice() {
            let ua = window.navigator.userAgent.toLocaleLowerCase();
            let isIOS = /iphone|ipad|ipod/.test(ua);
            let isAndroid = /android/.test(ua);
            return {
                isIOS: isIOS,
                isAndroid: isAndroid
            };
        },
        isTabOpenPage() {
            //判断是否tab页打开的
            if (window.PPDWebUI.os.inApp) {
                const source = this.$route.query.source;
                if (source) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        compareAppVer() {
            if (window.PPDWebUI.os.inApp) {
                let appV = window.PPDWebUI.os.buildVersion;
                let res = this.versionStringCompare(appV, '9.4.0');
                return res;
            }
        },
        versionStringCompare(currVer, targetVer) {
            var sources = currVer.split('.');
            var dests = targetVer.split('.');
            var maxL = Math.max(sources.length, dests.length);
            var result = 0;
            for (let i = 0; i < maxL; i++) {
                let preValue = sources.length > i ? sources[i] : 0;
                let preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
                let lastValue = dests.length > i ? dests[i] : 0;
                let lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
                if (preNum < lastNum) {
                    result = -1;
                    break;
                } else if (preNum > lastNum) {
                    result = 1;
                    break;
                }
            }
            return result;
        }
    }
};
